import { createPortal } from 'react-dom';
import { useIdleLogout } from '../hooks/useIdleLogout';

// Self-contained idle auto-logout. Mount it anywhere inside the authenticated
// app; the warning renders via a portal to document.body, so its position in
// the tree doesn't matter. When idle exceeds the timeout it calls onTimeout
// (which should sign the user out).
export default function IdleTimeout({ enabled, timeoutMs, warningMs, onTimeout }) {
  const { warningSecondsLeft, stayActive } = useIdleLogout({
    enabled,
    timeoutMs,
    warningMs,
    onTimeout,
  });

  if (warningSecondsLeft === null) return null;

  const overlay = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15, 23, 42, 0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2147483647,
  };
  const box = {
    background: '#fff',
    borderRadius: 8,
    padding: '24px 28px',
    maxWidth: 380,
    width: '90%',
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
    fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif',
    textAlign: 'center',
  };
  const button = {
    background: '#1e293b',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    padding: '10px 20px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  };

  return createPortal(
    <div style={overlay} role="dialog" aria-modal="true" aria-label="Session about to expire">
      <div style={box}>
        <h2 style={{ margin: '0 0 8px', fontSize: 18, color: '#1e293b' }}>Still there?</h2>
        <p style={{ margin: '0 0 18px', fontSize: 14, color: '#475569' }}>
          For your security you'll be signed out in {warningSecondsLeft} second
          {warningSecondsLeft === 1 ? '' : 's'} due to inactivity.
        </p>
        <button style={button} onClick={stayActive}>
          Stay signed in
        </button>
      </div>
    </div>,
    document.body
  );
}
